export const colors = {
  transactional: {
    base: '#ff6200',
    decreased50: '#feb07f',
    shaded: '#ac0111',
    dark: '#770012',
  },
  notTransactional: {
    base: '#495867',
    shaded: '#044cc3',
    dark: '#004175',
    gray: '#767676',
    red: '#d60303',
  },
  neutral: {
    transparent: 'transparent',
    red: 'red',
    white: '#ffffff',
    grayCold: '#595959',
    grayMedium: '#8c8c8c',
    grayLight: '#f5f5f5',
    color1: '#f8f8f8',
    color2: '#e1e1e1',
    color3: '#bfbfbf',
    gray: '#333333',
    silver: '#BBBBBB',
    green: '#008A00',
    codGray: '#131313',
    lightGray: '#EEEEEE',
  },
} as const;
